<!-- Explore Feature (ef) starts -->
<!-- <div class="one3d-explore-feature"> -->
<ion-header mode="md" class="d-none">
  <ion-toolbar class="one3d-ef-header">
    <ion-title class="one3d-ef-header-title" translate
      >FEATURE_SHOWCASE.EXPLORE_FEATURE</ion-title
    >
    <ion-button
      expand="full"
      class="one3d-ef-close-btn"
      slot="end"
      [disabled]="isFeaturePlaying"
      (click)="closeModal()"
      (keypress)="closeModal()"
    >
      <span><ion-icon name="close"></ion-icon></span>
      {{ "FEATURE_SHOWCASE.CLOSE" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content class="one3d-ef-feature-wrapper d-none">
  <ion-text>
    <h1 class="one3d-ef-feature-title">{{ selectedFeature?.feature_name }}</h1>
  </ion-text>
  <div class="one3d-ef-feature-flex">
    <ion-row class="one3d-ef-feature-flex-row one3d-scrollable-wrapper-custom">
      <ion-col class="ion-no-padding" size="12">
        <p class="one3d-ef-feature-desc">
          {{ selectedFeature?.feature_desc }}
          <!-- ? selectedFeature?.feature_desc
          : "No Description" -->
        </p>
      </ion-col>
    </ion-row>
    <!-- <ion-row class="one3d-ef-bottom">
      <ion-button
        class="one3d-ef-arrow-btn"
        (click)="goToPreviousFeature()"
        expand="block"
        fill="clear"
        [disabled]="
          (currentIndex == 0 && featureCategorySelected == categories[0]) ||
          isFeaturePlaying
        "
      >
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-col class="one3d-ef-bottom-col" size="6"> -->
    <!-- <span
        *ngFor="let item of featuresLength; let z = index"
        [ngClass]="{ 'one3d-active': currentIndex == z }"
        class="one3d-dot"
      ></span> -->
    <!-- <span class="one3d-ef-bottom-category ff-primary">
          {{ featureCategorySelected }}
        </span>
        <span class="one3d-ef-bottom-indexing ff-secondary">
          {{ currentIndex + 1 }}/{{ featuresLength?.length }}
        </span>
      </ion-col>
      <ion-button
        class="one3d-ef-arrow-btn"
        (click)="goToNextFeature()"
        expand="block"
        fill="clear"
        [disabled]="
          (currentIndex + 1 == featuresLength?.length &&
            featureCategorySelected == categories[categories.length - 1]) ||
          isFeaturePlaying
        "
      >
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-row> -->
    <!-- New Bottom Navigation -->
    <div class="one3d-ef-footer">
      <div class="on3d-ef-footer-category">
        <div class="one3d-footer-category-details">
          <span>{{ featureCategorySelected | translate }}</span>
          <span>{{ currentIndex + 1 }}/{{ featuresLength?.length }}</span>
        </div>
        <div class="one3d-footer-bar-wrapper">
          <div
            class="one3d-footer-bar"
            [ngStyle]="{
              width: ((currentIndex + 1) / featuresLength?.length) * 100 + '%'
            }"
          ></div>
        </div>
      </div>
      <div class="one3d-ef-footer-navigation">
        <button (click)="muteAudio()" class="one3d-footer-mute-btn">
          <img
            [src]="
              !muteMusic
                ? 'assets/img/icons/one3d-mute-icon.svg'
                : 'assets/img/icons/one3d-play-music-icon.svg'
            "
            alt="mute-button"
          />
          <span>
            {{
              (!muteMusic ? "FEATURE_SHOWCASE.MUTE" : "FEATURE_SHOWCASE.PLAY")
                | translate
            }}
          </span>
        </button>
        <div class="one3d-footer-nav">
          <button
            class="one3d-footer-nav-btn"
            (click)="goToPreviousFeature()"
            expand="block"
            fill="clear"
            [disabled]="
              (currentIndex === 0 &&
                featureCategorySelected === categories[0]) ||
              isFeaturePlaying
            "
          >
            <img
              src="assets/img/icons/one3d-left-arrow-icon.svg"
              alt="left arrow icon"
            />
          </button>
          <button
            class="one3d-footer-nav-btn"
            (click)="goToNextFeature()"
            [disabled]="
              (currentIndex + 1 === featuresLength?.length &&
                featureCategorySelected ===
                  categories[categories.length - 1]) ||
              isFeaturePlaying
            "
          >
            <img
              src="assets/img/icons/one3d-right-arrow-icon.svg"
              alt="right arrow icon"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</ion-content>
<!-- </div> -->
<!--New Mobile UI for Feature Showcase Reels Starts Here-->
<div #newFeatureContainer class="one3d-mobile-features-main-container">
  <div class="one3d-mf-main">
    <!-- <button expand="full" class="one3d-ef-close-btn" slot="end" [disabled]="isFeaturePlaying" (click)="closeModal()">
      <span>
        <img src="assets/img/icons/one3d-arrow-back-white.svg" alt="arrow back white" />
        Back
      </span>
    </button> -->
    <span class="one3d-features-indicator-progress-bar" style="display: none;"></span>
    <div
      class="one3d-arrow-bottom-indicator"
      *ngIf="showSwipeMore"
      (click)="goToNextFeature()"
      (keypress)="goToNextFeature()"
    >
      <span class="one3d-swipe-up-for-more">Swipe up for more</span>
      <div class="arrow-sliding">
        <div class="one3d-animated-arrow"></div>
      </div>
      <div class="arrow-sliding delay1">
        <div class="one3d-animated-arrow"></div>
      </div>
    </div>
    <span
      class="one3d-sound-off"
      (click)="muteAudio()"
      (keypress)="muteAudio()"
    >
      <img
        [src]="
          !muteMusic
            ? 'assets/img/icons/one3d-sound-on.svg'
            : 'assets/img/icons/one3d-sound-off.svg'
        "
        alt="mute-button"
      />
    </span>
    <span class="one3d-features-menu-icon" id="main-content">
      <ion-menu-toggle>
        <img
          src="assets/img/icons/one3d-menu-icon.svg"
          alt="features menu icon"
        />
      </ion-menu-toggle>
    </span>
    <ion-menu
      side="end"
      class="one3d-mf-panel-ion-menu"
      contentId="main-content"
    >
      <div class="one3d-mf-panel-main-container h-100">
        <!--Mobile Features Right Hand Side Panel Starts Here-->
        <div class="one3d-mf-panel-wrapper">
          <div class="one3d-mf-panel-wrap">
            <div class="one3d-mf-panel">
              <div class="one3d-mf-panel-head">
                <div class="one3d-mf-count">
                  <span class="one3d-mf-current">{{
                    currentIndexAll + 1
                  }}</span>
                  /
                  <span class="one3d-mf-total-count">{{
                    allFeatures?.length
                  }}</span>
                  <!-- <span class="one3d-mf-total">Total Features</span> -->
                </div>
                <span class="one3d-mf-close-panel">
                  <ion-menu-toggle>
                    <img
                      src="assets/img/icons/one3d-x-cross.svg"
                      alt="x cross"
                    />
                  </ion-menu-toggle>
                </span>
              </div>
              <ion-accordion-group
                class="one3d-mf-accordion-group"
                expand="inset"
              >
                <ion-accordion
                  class="one3d-mf-accordion-box"
                  lines="none"
                  no-lines
                  *ngFor="let featureCategory of features"
                  [value]="featureCategory.category_id"
                >
                  <ion-item
                    slot="header"
                    color="light"
                    class="one3d-mf-accordion-heading"
                    lines="none"
                    no-lines
                  >
                    <ion-label>{{ featureCategory.featureCategory }}</ion-label>
                  </ion-item>
                  <div
                    class="one3d-mf-accordion-content-box ion-padding"
                    slot="content"
                  >
                    <ul class="one3d-mf-list">
                      <li
                        class="one3d-mf-list-li"
                        *ngFor="let feature of featureCategory?.featureList"
                        (click)="selectFeature(featureCategory, feature)"
                        (keypress)="selectFeature(featureCategory, feature)"
                        [class.active]="
                          selectedFeature?.feature_id === feature?.feature_id
                        "
                      >
                        <ion-text class="one3d-mf-list-text">
                          {{ feature?.feature_name }}
                        </ion-text>
                      </li>
                    </ul>
                  </div>
                </ion-accordion>
              </ion-accordion-group>
            </div>
          </div>
        </div>
        <!--Mobile Features Right Hand Side Panel Ends Here-->
      </div>
    </ion-menu>
    <div class="one3d-mf-count-outside">
      <div class="one3d-mf-count">
        <span class="one3d-mf-current">{{ currentIndexAll + 1 }}</span> /
        <span class="one3d-mf-total-count">{{ allFeatures?.length }}</span>
      </div>
    </div>
  </div>
  <div
    class="one3d-mf-main"
    *ngFor="let feature of allFeatures"
    [@cardAnimator]="globalService.animationState"
  >
    <div class="one3d-mf-bottom-content-wrap">
      <div class="one3d-mf-bottom-content">
        <h3>
          <ion-text>
            {{ selectedFeature?.feature_name }}
          </ion-text>
        </h3>
        <p
          class="one3d-feature-desc-load-more"
          *ngIf="!!selectedFeature?.feature_desc"
        >
          {{ updateText(selectedFeature?.feature_desc) }}
          <span
            class="one3d-view-more-text"
            (click)="toggleView()"
            (keypress)="toggleView()"
          >
            <span>{{ isExpanded ? "Less" : "More" }}</span>
          </span>
        </p>
      </div>
      <div class="one3d-heart-right-portion" style="display: none">
        <img
          src="assets/img/icons/one3d-heart-white.svg"
          alt="heart white icon"
        />
        <ion-text> 234 </ion-text>
      </div>
    </div>
  </div>
</div>
<!--New Mobile UI for Feature Showcase Reels Ends Here-->
